import { SvgIcon } from '@material-ui/core'

export default function EnabledCheckMark() {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M7.31673 3.76876C10.4043 3.42368 13.5957 3.42368 16.6832 3.76876C17.8424 3.89832 18.8601 4.52519 19.5038 5.43559L11.5 13.4393L9.03033 10.9697C8.73744 10.6768 8.26256 10.6768 7.96967 10.9697C7.67678 11.2626 7.67678 11.7374 7.96967 12.0303L10.9697 15.0303C11.2626 15.3232 11.7374 15.3232 12.0303 15.0303L20.1458 6.9149C20.1682 7.02447 20.1862 7.13573 20.1994 7.24849C20.5686 10.4054 20.5686 13.5946 20.1994 16.7515C19.9845 18.5885 18.5096 20.0271 16.6832 20.2313C13.5957 20.5763 10.4043 20.5763 7.31673 20.2313C5.49035 20.0271 4.01545 18.5885 3.8006 16.7515C3.43137 13.5946 3.43137 10.4054 3.8006 7.24849C4.01545 5.41153 5.49035 3.97288 7.31673 3.76876Z"
                fill="#85E0A3"
            />
        </SvgIcon>
    )
}
